/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { handleResponse } from '@opengeoweb/api';
import { sessionStorageProvider } from '@opengeoweb/shared';
import type {
  LocationListResult,
  LocationDetail,
} from '../../components/LocationSearch/types';

const config = sessionStorageProvider.getConfig();

let locationBaseUrl: string | undefined = config.GW_LOCATION_BASE_URL;

const getLocationBaseUrl = (): string => {
  if (locationBaseUrl === undefined) {
    const config = sessionStorageProvider.getConfig();
    locationBaseUrl = config.GW_LOCATION_BASE_URL || '';
  }
  return locationBaseUrl;
};

export const getLocationList = async (
  search: string,
): Promise<LocationListResult[]> =>
  fetch(`${getLocationBaseUrl()}/locations?search=${search}`).then(
    handleResponse,
  ) as Promise<LocationListResult[]>;

export const getLocationDetail = async (
  id: string,
  source: string,
): Promise<LocationDetail> =>
  fetch(
    `${getLocationBaseUrl()}/locationdetail?id=${id}&source=${source}`,
  ).then(handleResponse) as Promise<LocationDetail>;
